import { Outlet } from "react-router-dom";
import { Map } from "~/components/map";

/**
 * Layout for the Explore Map (/m/*).
 * Provides a persistent map instance for public map viewing.
 */
export default function ExplorerLayout() {
  return (
    <Map.Canvas>
      <Outlet />
    </Map.Canvas>
  );
}
